import React, { useRef, useEffect, useState } from 'react';
import { VideoTexture, Vector3, Vector2, MeshBasicMaterial, BackSide } from 'three';
import UserMediaService from '../../../services/UserMediaService';
import TestVideo from '../../../assets/test.mp4';
import { userAvatarMaterial, userAvatarVideoBoxGeometry, userAvatarVideoPlaneGeometry, userAvatarVideoPlaneDimensions, userAvatarTvDepth } from '../SharedMeshes/SharedMeshes';
import { useThree, useFrame } from '@react-three/fiber';

const VideoMesh: React.FC<{ track: MediaStreamTrack | undefined, videoHeight: number, trackSrc?: string }> = ({ track, videoHeight, trackSrc }) => {
  const [texture, setTexture] = useState<VideoTexture | null>(null);
  const { invalidate } = useThree();
  
  useFrame(() => {
    invalidate();
  });

  useEffect(() => {
    let videoEl = document.createElement('video');

    const handleCanPlay = () => {
      if (!texture) {
        const videoTexture = new VideoTexture(videoEl);
        setTexture(videoTexture);
      }
      videoEl.play().catch((error) => console.error('Error playing video:', error));
    };

    if (track && track.readyState === 'live') {
      videoEl.srcObject = new MediaStream([track]);
      videoEl.addEventListener('canplay', handleCanPlay);
    }

    if (trackSrc) {
      videoEl.src = TestVideo;
      videoEl.muted = true;
      videoEl.addEventListener('canplay', handleCanPlay);
    }

    return () => {
      if (videoEl) {
        videoEl.pause();
        videoEl.srcObject = null;
        videoEl.removeEventListener('canplay', handleCanPlay);
      }
      if (texture) {
        texture.dispose();
      }
    };
  }, [track?.readyState, trackSrc]);

  return (
    <mesh position-y={userAvatarVideoPlaneDimensions.height}>
    { userAvatarMaterial }
    { userAvatarVideoBoxGeometry }
      <mesh position-z={- userAvatarTvDepth / 2 - 0.01}>
        { userAvatarVideoPlaneGeometry }
        {texture && <meshBasicMaterial map={texture} side={BackSide} />}
      </mesh>
    </mesh>
  );
};

export default VideoMesh;